<script setup>
    import Doc from '~icons/my-icons/doc';
</script>

<template>
    <button 
        type="button" 
        ref="tooltip"  
        :class="customClass" 
        :data-content="content"
    >
        <slot></slot>
    </button>
</template>

<script>

    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css';

    export default {
        props: ['content', 'class', 'position'],
        data: function() {
            return {
                customClass: this.class ? this.class : '',
                pos: this.position ? this.position : 'bottom'
            }
        }, 
        mounted() {
            tippy(this.$refs.tooltip, {
                content: this.content,
                placement: this.pos
            });
        }
    };

</script>


<style lang="scss" scoped>
    .tippy-box {
        background-color: theme('colors.grey-800');
        font-size: 0.875rem;
        font-weight: 500;
        line-height:  1.25rem;
        max-width: 468px;
        padding: 0;
        max-width: 160px;
    }
    .tippy-arrow {
        background-color: theme('colors.grey-800');
    }
    .tippy-content {
        padding: 1rem;
        margin: 0;
    }
</style>